// RouteHistoryProvider.jsx
import { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigationType, useNavigate } from 'react-router-dom';

const RouteHistoryCtx = createContext(null);

export function RouteHistoryProvider({ children }) {
  const location = useLocation();
  const navType = useNavigationType(); // PUSH / POP / REPLACE
  const stackRef = useRef([]); // [{pathname, key}]
  const navigate = useNavigate();

  // catat setiap perpindahan rute
  useEffect(() => {
    const { pathname, key } = location;
    const stack = stackRef.current;

    if (navType === 'REPLACE') {
      // ganti entry terakhir
      stack.pop();
      stack.push({ pathname, key });
    } else if (navType === 'POP') {
      // biarkan apa adanya; opsi: sinkronkan bila perlu
      // (biasanya tak perlu karena kita hanya pakai untuk hitung delta)
    } else {
      // PUSH (default)
      const last = stack[stack.length - 1];
      if (!last || last.pathname !== pathname) {
        stack.push({ pathname, key });
      }
    }
  }, [location, navType]);

  const backTo = (targetPath) => {
    const stack = stackRef.current;
    // cari target dari belakang (skip current index)
    const currIdx = stack.length - 1;
    const targetIdx = [...stack]
      .slice(0, currIdx) // jangan pakai current
      .map((e) => e.pathname)
      .lastIndexOf(targetPath);

    if (targetIdx >= 0) {
      const delta = currIdx - targetIdx; // langkah mundur
      navigate(-delta); // mendarat di target
    } else {
      // kalau tidak ada di stack: fallback replace agar tak nambah entry
      navigate(targetPath, { replace: true });
      // optional: reset stackRef.current = [{ pathname: targetPath, key: crypto.randomUUID() }]
    }
  };

  return (
    <RouteHistoryCtx.Provider value={{ backTo }}>
      {children}
    </RouteHistoryCtx.Provider>
  );
}

export function useRouteHistory() {
  const ctx = useContext(RouteHistoryCtx);
  if (!ctx) throw new Error('Wrap with <RouteHistoryProvider>');
  return ctx;
}
